import { useAtom } from 'jotai';
import React from 'react';

import { jobsListLoadableAtom } from '../../store/Atoms';
import LoadableRefresherList from './LoadableRefresherList';

const JobsList: React.FC = () => {
    const [value, refresh] = useAtom(jobsListLoadableAtom);

    return (
        <LoadableRefresherList
            value={value}
            refresh={refresh}
            viewingPastJobs={false}
        />
    );
};

export default JobsList;
